import { useTranslation } from "react-i18next";
import { Header } from "src/components";
import styles from './styles.module.css';
import data from './data';
import useScrollToTop from "src/hooks/useScrollToTop";
import { isRTL } from "src/utils/global";
import { useCallback, useEffect, useState } from "react";
import { useLocation } from 'react-router-dom';


const Services = () => {
    const { i18n, t } = useTranslation(['services']);
    const { hash } = useLocation();
    const [width, setWidth] = useState<number>(0);

    useScrollToTop(hash);

    const getWidth = useCallback((hasWindow: boolean) => {
        const width = hasWindow ? window.innerWidth : 0;
        return width
    }, [window.innerWidth]);



    useEffect(() => {
        if (hash) {
            const element = document.getElementById(hash.replace('#', ''));
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        }
    }, [hash]);

    useEffect(() => {
        const hasWindow = typeof window !== 'undefined';
        setWidth(getWidth(hasWindow));

        if (hasWindow) {
            const handleResize = () => {
                setWidth(getWidth(hasWindow));
            }
            window.addEventListener('resize', handleResize);
            return () => window.removeEventListener('resize', handleResize);
        }
    }, []);


    return (<section className={[styles.container, isRTL() && styles.rtl].join(' ')}>
        <Header title={t("header.title")} />
        <div className="container">
            <div className={styles.items}>
                {data.map((item, index) => {
                    const isEven = index % 2 === 0;
                    return (
                        <div key={item.id} className={styles.item} id={item.id}>
                            <div className="row">
                                {!isEven && width > 1119 ? (
                                    <>
                                        {/* Content first for odd items */}
                                        <div className="col-lg-7 col-12">
                                            <div className={styles.content}>
                                                <h3 className={styles.title}>
                                                    {item[i18n.language].title}
                                                </h3>
                                                <ul>
                                                    {item[i18n.language].list.map((itm: any, idx: number) => (
                                                        <li key={"item__list__" + idx}>{itm}</li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="col-lg-5 col-12 m-auto">
                                            <div className={styles.img__con}>
                                                <img src={item.img} alt={item.ar.title} />
                                            </div>
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        {/* Image first for even items */}
                                        <div className="col-lg-5 col-12 m-auto">
                                            <div className={styles.img__con}>
                                                <img src={item.img} alt={item.ar.title} />
                                            </div>
                                        </div>
                                        <div className="col-lg-7 col-12">
                                            <div className={styles.content}>
                                                <h3 className={styles.title}>
                                                    {item[i18n.language].title}
                                                </h3>
                                                <ul>
                                                    {item[i18n.language].list.map((itm: any, idx: number) => (
                                                        <li key={"item__list__" + idx}>{itm}</li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                    </>

                                )}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    </section>

    )
}

export default Services;